import axios from 'axios';
import swal from 'sweetalert2';

const state = {

};

const getters = {

};

const actions = {
    async addAssessmentBatch(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.addAssessmentBatchUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getBatches(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getBatchesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getBatchPayments(state, id) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getBatchPaymentsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { 'id' : id },{ headers: header });// make api call
        return response.data;
    },
    async addAssessmentBatchPayment(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.addAssessmentBatchPaymentUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async deleteBatchPayment(state, id) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.deleteBatchPaymentUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { 'id' : id },{ headers: header });// make api call
        return response.data;
    },
    async getBatchPaymentBreakdowns(state, id) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getBatchPaymentBreakdownsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { 'id' : id },{ headers: header });// make api call
        return response.data;
    },
    async addPaymentBreakdown(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.addPaymentBreakdownUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async deleteBatchPaymentBreakdown(state, id) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.deleteBatchPaymentBreakdownUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { 'id' : id },{ headers: header });// make api call
        return response.data;
    },
    async completeAssessmentBatch(state, id) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.completeAssessmentBatchUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { 'id' : id },{ headers: header });// make api call
        return response.data;
    },
    async deleteAssessmentBatch(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.deleteAssessmentBatchUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async changeBatchStatus(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.changeBatchStatusUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getSearchedBatches(state, key) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getSearchedBatchesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { 'key' : key },{ headers: header });// make api call
        return response.data;
    },
    async getAssessmentTypes(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentTypesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async addAssessmentType(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.addAssessmentTypeUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async deleteAssessmentType(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.deleteAssessmentTypeUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getAssessmentApplications(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentApplicationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getAssessmentApplicant(state, id) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentApplicantUrl;
        const header = {'X-Assessment-Token': authorizationToken};
        const response = await axios.post(url, { 'id' : id },{ headers: header });// make api call
        return response.data;
    },
    async approveAssessmentApplication(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.approveAssessmentApplicationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async saveAssessmentApplicantData(state, data) {// get user Appointments
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.saveAssessmentApplicantDataUrl;
        const header = {'X-Assessment-Token': authorizationToken};
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;
    },
    async addPreviousAssessmentEntry(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.addPreviousAssessmentEntryUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getPreviousAssessmentEntries(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getPreviousAssessmentEntriesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async deletePreviousAssessmentBatch(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.deletePreviousAssessmentBatchUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getAssessmentPayments(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getAssessmentPaymentsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async changeSeatStatus(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.changeSeatStatusUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async viewAssessmentDocument(state, data) {// fetch user document function
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.assessmentDocumentViewUrl;
        const header = {'X-Assessment-Token': authorizationToken};
        try {
            const response = await axios.post(url, data,
                        { 
                            responseType: 'blob', 
                            headers: header 
                        });// make api call
            const blobUrl = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
            );

            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
            return blobUrl;
        } catch (error) {
            let errorMsg = data.msg;
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMsg = json.msg || json.message || text;
                } catch {
                    errorMsg = data.msg + ' ' + error.message;
                }
            } else {
                errorMsg = error.message || errorMsg;
            }
            swal.fire('Error!', error + ' - ' + errorMsg, 'error');
        }
    },
    async printExamCard(state, data) {
        const authorizationToken = state.rootState.url.authorizationToken;
        // const url = state.rootState.url.printAssessmentCardUrl;
        const header = {'X-Assessment-Token': authorizationToken};
        try {
            const response = await axios.post(data.url, data,
            {
                responseType: 'blob',
                headers: header,
            }
            );
            const fileUrl = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
            );
            window.open(fileUrl, '_blank');
        } catch (error) {
            swal.fire("Error!", "Failed to print exam card:," + error, "error");
        }
    },
    async downloadAssessmentFiles(state, data) {
        const authorizationToken = state.rootState.url.authorizationToken;
        try {
            const response = await axios.post( data.url, data,
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${authorizationToken}`
                    },
                }
            );
            // trigger an actual file download (zip/archive), not just open in a tab
            const contentType = response.headers['content-type'] || data.contentType;
            const blobUrl = URL.createObjectURL(new Blob([response.data], { type: contentType }));

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = data.fileName; // adjust extension to match actual file type
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);            
        } catch (error) {
            let errorMsg = data.msg;
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMsg = json.msg || json.message || text;
                } catch {
                    errorMsg = data.msg + ' ' + error.message;
                }
            } else {
                errorMsg = error.message || errorMsg;
            }
            swal.fire('Error!', error + ' - ' + errorMsg, 'error');
        }
        return false;
    }
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}